import { render } from "./PaymentDetail.vue?vue&type=template&id=710e7568"
import script from "./PaymentDetail.vue?vue&type=script&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&lang=js"

import "./PaymentDetail.vue?vue&type=style&index=0&id=710e7568&lang=less"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__